import React, { useEffect, useState } from 'react';
import useToken from '../../useToken'
import { useSelector, useDispatch } from 'react-redux';
import { fetchData } from '../../features/environment/sensorsSlice';
import { startOfWeek, addDays, format } from "date-fns";
import DataTable from 'react-data-table-component';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  title: {
    marginLeft: 10,
  },
});

export default function GreenhouseEnvironment() {
  const classes = useStyles();
  const {token, setToken} = useToken()
  const dispatch = useDispatch()
  const sensors = useSelector((state: any) => state.sensors.sensorsData);

    useEffect(() => {
      dispatch(fetchData({token}))
    }, [dispatch]);

  const sensorsData = sensors.data.Data || []
  return (
    <React.Fragment>
      <Typography variant="h6" className={classes.title}>
        Greenhouse Environment
      </Typography>
      <Grid container spacing={3}>
      {
        sensorsData.map((sensor) =>(
          <Grid item xs key={sensor.section}>
          <Card>
          <CardContent>
            <Typography variant="h6" component="h2">
              {sensor.section}
            </Typography>
            <Typography variant="body2">
              Air Temp (&deg;C): {sensor.air_temp}
            </Typography>
            <Typography variant="body2">
              Air Humidity (%rh): {sensor.air_hum}
            </Typography>
            <Typography variant="body2">
              UV(lux): {sensor.illuminance}
            </Typography>
            <Typography variant="body2">
              Soil EC (ds/m): {sensor.soil_ec}
            </Typography>
            <Typography variant="body2">
              Soil Temp (&deg;C): {sensor.soil_temp}
            </Typography>
            <Typography variant="body2">
              Soil Moist (%rh): {sensor.soil_hum}
            </Typography>
            
          </CardContent>
          </Card>
          </Grid>
      ))}
      </Grid>
    </React.Fragment>
  );
}
